import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

let styles = {
    marginTop: '30px',
};

class MemberNotFoundComponent extends Component {
    render() {
        return (
            <div className="container text-center">
                <h1>{this.props.t('memberNotFound.title')}</h1>
                <Link to="/" className="btn btn-success" style={styles}>
                    {this.props.t('common.back')}
                </Link>
            </div>
        );
    }
}

export default withTranslation()(MemberNotFoundComponent);
